import { getTranslations } from 'helpers/translations';
import { distinctLangaugeVariants } from 'lib/locales/languages';
import { Category } from 'models';
import slugify from 'slugify';

export const getOverviewVariants = async (overviewPage: Category) => {
  const response = await Promise.all(
    distinctLangaugeVariants.map(async (languageCodename) => {
      const { multiple } = await getTranslations(languageCodename);
      return [languageCodename, `/${slugify(multiple(overviewPage), { lower: true })}`];
    }),
  );
  return response.reduce((obj, [key, value]) => {
    obj[key] = value;
    return obj;
  }, {} as { [key: string]: string });
};

export const getCareersVariants = async ({
  withTalentCommunityUrl = false,
  url,
}: {
  withTalentCommunityUrl?: boolean;
  url?: string;
}) => {
  const response = await Promise.all(
    distinctLangaugeVariants.map(async (languageCodename) => {
      const { multiple, url: urlTranslate } = await getTranslations(languageCodename);
      return [
        languageCodename,
        `/${slugify(multiple('career'), { lower: true })}${
          withTalentCommunityUrl
            ? `/${slugify(urlTranslate('talentCommunitiesUrl'), { lower: true })}`
            : url
            ? `/${url}`
            : ''
        }`,
      ];
    }),
  );
  return response.reduce((obj, [key, value]) => {
    obj[key] = value;
    return obj;
  }, {} as { [key: string]: string });
};

export const getContactUsVariants = async (subcategory?: string) => {
  const response = await Promise.all(
    distinctLangaugeVariants.map(async (languageCodename) => {
      const { multiple, url } = await getTranslations(languageCodename);
      return [
        languageCodename,
        `/${slugify(multiple('contactUsUrl'), { lower: true })}${
          subcategory ? `/${slugify(url(subcategory), { lower: true })}` : ''
        }`,
      ];
    }),
  );
  return response.reduce((obj, [key, value]) => {
    obj[key] = value;
    return obj;
  }, {} as { [key: string]: string });
};
